import { IconButton, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './ChatPopup.css';

interface IChatPopupProps {
  src: string;
  onClose(): void;
}

export const ChatPopup: React.FC<IChatPopupProps> = ({ src, onClose }) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = () => setIsLoading(false);

  return (
    <div className={cn(styles['container'])}>
      <span className={styles['close']}>
        <IconButton aria-label="Закрыть" icon={<IconActionClose16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      <iframe data-testid="ChatModal" className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
    </div>
  );
};
